<template lang="pug">
  .page-container
    Toolbar
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container(v-if='isLoading')
      Loading

    v-container(v-if='!isLoading')
      v-layout
        v-flex.order-detail
          div.title {{ $t("order.orderDetail") }}
          div {{ $t("order.orderSn") }}
            span {{orderDetail.sn}}
          div {{ $t("order.orderTime") }}
            span {{orderDetail.createTime}}
          div {{ $t("order.storeName") }}
            span {{userInfo.name}}
          div.title {{ $t("order.shoppingInfo") }}
          div {{ $t("order.receiver") }}
            span {{orderDetail.receiveMan}}
          div {{ $t("order.telephone") }}
            span {{orderDetail.receivePhone}}
          div {{ $t("order.address") }}
            span {{orderDetail.receiveArea}} {{orderDetail.receiveCityName}} {{orderDetail.receiveAddress}}

        v-flex
          table.product-table
            thead
              tr
                th {{ $t("shoppingCart.productId") }}
                th {{ $t("shoppingCart.productImg") }}
                th {{ $t("shoppingCart.productName") }}
                th {{ $t("shoppingCart.unitPrice") }}
                th {{ $t("shoppingCart.quantity") }}
                th {{ $t("shoppingCart.unit") }}
                th {{ $t("shoppingCart.subtotal") }}
            tbody
              tr(v-for='(item, index) in orderDetail.goods')
                td {{item.spuId}}
                td
                  img.product-img(:src='item.cover')/
                td
                  .name {{item.spuName}}
                  div {{item.specInfo}}
                td {{item.amount}}
                td {{item.num}}
                td {{item.unit}}
                td.price {{item.totalPrice}}

</template>

<script>
import { mapState } from "vuex";
import order from "../../api/order.js";
import Toolbar from "../../components/common/toolbar";
import Loading from "../../components/common/loading";

export default {
  computed: {
    ...mapState(["userInfo"]),
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "order-list" },
          disabled: false,
          text: this.$t("nav.orderList")
        },
        {
          to: { name: "order-detail" },
          disabled: true,
          text: this.$t("nav.orderDetail")
        }
      ];
    }
  },

  mounted() {
    this.loadOrderDetail();
  },

  data() {
    return {
      orderDetail: {},
      isLoading: true
    };
  },

  components: {
    Toolbar,
    Loading
  },

  methods: {
    async loadOrderDetail() {
      this.isLoading = true;
      try {
        const res = await order.loadOrderDetail({
          orderId: this.$route.params.orderId
        });
        this.isLoading = false;

        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          res.data.data.goods.map((item, index) => {
            res.data.data.goods[index].totalPrice = (
              parseInt(item.num) * parseFloat(item.amount)
            ).toFixed(2);
          });
          this.orderDetail = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped lang="sass" src="./detail.sass"></style>
